import React from "react";
import withStyles from '@mui/styles/withStyles';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import Button from '@mui/material/Button';


const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const DeleteDecoteRetourExcluDialog = ({ classes, onClose, onClickDelete, decoteRetourExclu, niveaux }) => {
       
    const remove = () => {
        onClickDelete(decoteRetourExclu.id);
    };

    let niveau = niveaux.find(n => n.id === decoteRetourExclu.niveau);

    return (
        <Dialog open>
            <DialogTitle>Suppression d'une exclusion pour les décôtes au retour</DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <p>Êtes-vous sûr de vouloir supprimer l'exclusion pour le niveau <strong>{niveau.libelle}</strong> avec le code <strong>{decoteRetourExclu.code}</strong> ?</p>


            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={remove}
                    variant="contained"
                    color="secondary"
                >
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(DeleteDecoteRetourExcluDialog);
